var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['wheel', `wheel_font-size--${_vm.config.felder.length}`],style:(_vm.wheelStyle),attrs:{"id":"wheel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }